import { ResponseCode } from '@/common/request/types';
import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLocale } from '@/modules/locale/model/locale';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive, watch } from 'vue';
import { useRoute } from 'vue-router';

export function usePromotionItemTranslate() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();

    const model = reactive({
        itemId: route.params.id,
        locale: null,
        title: '',
        description: '',
        hasData: false
    });

    const validations = {
        title: { required },
        locale: { required },
        description: {}
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => promotionService.text.get(model.itemId, model.locale),
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.title = data.title;
            model.description = data.description;
        },
        onError: ({ code }) => {
            if (code === ResponseCode.NothingFound) {
                model.hasData = false;
                model.title = '';
                model.description = '';
            } else router.push({ name: ROUTE_NAME_PROMOTION.ITEM.INDEX });
        },
        onFinally: () => v$.value.$reset()
    });

    const actions = {
        updateText: crudAction.excuteAndNotify({
            validator: v$,
            request: () => promotionService.text.update(model.itemId, model.locale, model.title, model.description),
            onSuccess: fetch
        }),
        removeText: crudAction.confirmAndRemove({
            request: () => promotionService.text.remove(model.itemId, model.locale),
            onSuccess: fetch
        })
    };

    watch(() => model.locale, fetch);

    return { model, v$, fetch, getListSupported, actions, localeSupportedOptions };
}
